// @flow
import React, { Component } from 'react';


export default class Footer extends Component {

    render () {
        return (
            <footer>
                © 2020 Copyright LauraNor
            </footer>);
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js